<template>
    <div>
        <header-nav :cur="3" />
        <!-- 搜索 -->
        <div class="nav">
            <div class="navtab">
                <span class="top">
                    首页&nbsp;>
                    <span @click="tograde()" class="gradetwo">班级</span>
                    >
                    <span class="infor">班级详情</span>
                </span>
                <div class="newbox">
                    <div>
                        <div class="newtop">班级学习中心</div>
                        <div class="newbot">加入班级，更快速的成长</div>
                    </div>
                    <div class="input">
                        <input placeholder="请输入您想要寻找的课程" type="text" />
                        <div class="select">搜索</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 班级介绍 -->
        <div class="navtab">
            <div class="intro">
                <img :src="$api.url+item.clazzImage" alt="" />
                <div class="rightbox">
                    <div class="name">
                        {{item.clazzName}}
                        <span>班级编码： {{item.clazzCode}}</span>
                    </div>
                    <div class="timebox">
                        <span>课时：{{item.clazzCode}}课时</span>
                        <span>限制报名人数：{{item.limitPeopleCount}}人</span>
                        <span>报名人数：不限</span>
                        <span>剩余名额：不限</span>
                    </div>
                    <div class="time">
                        <span>开课时间：{{item.startTime}}</span>
                        <span>结束时间：{{item.endTime}}</span>
                    </div>
                    <div class="cont ignore">
                        {{item.clazzDescribe}}
                    </div>
                    <div class="explain">
                        <span v-if="item.isExam==1">需要考试</span>        
                        <span class="span2" v-if="item.isCertificate==1">有证书</span>
                    </div>
                    <div class="money">
                        <!-- <div class="span1">￥{{item.clazzPrice}}</div> -->
                        <div class="must" @click="toapplyClazz(item.id)">
                            <img src="../../assets/img/grade/apply.svg" alt="" />
                            立即报名
                        </div>
                        <!-- <div class="add">加入购物车</div> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- 班级课程 -->
        <div class="navtab">
            <div class="title">班级下设课程</div>
        </div>
        <!-- 推荐课程 -->
        <div class="navtab">
            <div class="courselist">
                <div class="courbox" v-for="(obj, index) in courses" :key="index" @click="toCourseDetail(obj.id)">
                    <div class="play">
                        <img src="../../assets/img/index/ico_live_broadcast.svg" alt="" />
						<span v-if="obj.courseType ==1">录播</span>
						<span v-if="obj.courseType ==2">直播</span>
                    </div>
                    <div class="hour">{{ obj.lessionNum }}课时</div>
                    <img :src="$api.url+obj.courseImage" alt="" width="221px" height="136px" />
                    <div class="tit">{{ obj.courseName }}</div>
                   <div class="bottom">
                     <!--  <img :src="item.imgper" alt="" />
                   	<span class="person">3</span> -->
                   	<span class="person">访问数:{{obj.courseViewCount}}</span>
                       <!-- <span class="num">{{ item.num }}人</span> -->
                   	<span class="num">{{ obj.subjectName}}行业</span>
                   	
                       <!-- <span class="money">{{ item.lessionNum }}学时</span> -->
                   </div>
                </div>
            </div>
        </div>
        <v-pagination :total="total" :display='queryParams.pageSize' :current-page='queryParams.pageNum'
                      @pagechange="pagechange" style="padding-top: 80px;"></v-pagination>
        <footer-nav />
    </div>
</template>
<script>
import pagination from '@/components/common/pagination'
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
export default {
    components: {
        'v-pagination': pagination,
        'header-nav': headerNav,
        'footer-nav': footerNav,
    },
    data() {
        return {
            course: [
                {
                    cour: '36',
                    img: require('../../assets/img/index/course.jpg'),
                    title: 'AI软件复杂立体LOGO绘制',
                    imgper: require('../../assets/img/index/course.jpg'),
                    person: '郭伟',
                    num: '383',
                    money: 800.0,
                },
          
            ],
			id:'',
			item:'',
			courses:[],
			queryParams: {
			  pageNum: 1,
			  pageSize: 10,
			  courseName: null,
			  parentSubjectId: null,
			  subjectId: null,
			},
			total:1,
			pageCount:1,
			pageSize:15,
			pageNum:1,			
			subjectId:''
        };
    },
	created() {
		this.id = this.$route.query.id;
		this.queryClazzInfo(this.id);	
	},
    methods: {
		pagechange(currentPage){
			console.log(currentPage);
		    this.queryParams.pageNum=currentPage;
		    // ajax请求, 向后台发送 currentPage, 来获取对应的数据
		    this.getList();
		},
		queryClazzInfo(id){
			// Lambda写法
			this.$http.get(this.$api.url +'/papi/clazz/queryClazzById',{params:{'id':id}}).then((response) => {
			    this.item = response.data.data;	
				this.queryParams.subjectId = this.item.subjectId;
				this.getList();
			}, (response) => {
			    console.log("response"+response.data.length);
			});	
		},
		getList(){
			this.$http.get(this.$api.url +'/papi/course/list',{params:this.queryParams}).then((response) => {
			    this.courses=[];
			    this.courses = response.data.rows;	
				this.total = response.data.total;
			}, (response) => {
			    console.log("response"+response.data.rows.length);
			});
		},
	/* 	getList2(){
			this.$http.get(this.$api.url +'/papi/course/list',{params:{'subjectId':this.subjectId,'pageNum':pageNum,'pageSize':this.pageSize}}).then((response) => {
			    this.courses=[];
			    this.pageNum = pageNum;
				this.courses = response.data.rows;	
				this.total = response.data.total;
				if((this.total%this.pageSize)>0){
					this.pageCount = parseInt(this.total/this.pageSize)+1;
				}else{
					this.pageCount = this.total%this.pageSize;
				}
			}, (response) => {
			    console.log("response"+response.data.rows.length);
			});
		}, */
		toCourseDetail(id) {
		    //this.$router.push('/course/detail');
			this.$router.push({path:'/course/detail',query:{id:id}});
		},
        toapplyClazz(id) {
            this.$router.push({path:'/clazz/baoming',query:{id:id}} );
        },
        tograde() {
            this.$router.back(-1);
        },
    },
};
</script>
<style lang="less" scoped>
   // 公共
   .navtab {
       width: 1280px;
       margin: 0 auto;
   }
   .color {
       color: #2961EF !important;
   }
   .ignore {
       overflow: hidden;
       text-overflow: ellipsis;
       display: -webkit-box;
       -webkit-box-orient: vertical;
       -webkit-line-clamp: 2;
   }
   // 搜索
   .nav {
       background: #f7f8fa;
       width: 100%;
       height: 177px;
       .top {
           display: block;
           font-size: 16px;
   
           font-weight: 300;
           color: #777777;
           padding: 19px 0 24px;
           .gradetwo {
               cursor: pointer;
           }
           .infor {
               color: #2961EF;
           }
       }
       .newbox {
           display: flex;
           justify-content: space-between;
           align-items: center;
           .newtop {
               font-size: 26px;
               color: #000000;
               margin-bottom: 5px;
           }
           .newbot {
               font-size: 16px;
               color: #888888;
           }
           .input {
               width: 497px;
               height: 59px;
               background: #ffffff;
               box-shadow: 3px 3px 10px 1px rgba(11, 19, 72, 0.050980392156862744);
               border-radius: 30px;
               position: relative;
               input {
                   border: none;
                   position: absolute;
                   left: 30px;
                   top: 0;
                   height: 59px;
                   line-height: 59px;
                   width: 365px;
                   font-size: 16px;
   
                   font-weight: 300;
                   color: #777777;
               }
               .select {
                   position: absolute;
                   right: 12px;
                   top: 8px;
                   width: 74px;
                   height: 43px;
                   line-height: 43px;
                   background: #2961EF;
                   border-radius: 30px;
                   font-size: 16px;
   
                   font-weight: 300;
                   color: #ffffff;
                   text-align: center;
               }
           }
       }
   }
   // 班级介绍
   .intro {
       padding: 36px 0;
       display: flex;
       align-items: center;
       img {
           width: 486px;
           height: 295px;
           margin-right: 19px;
       }
       .rightbox {
           width: 100%;
           .name {
               font-size: 24px;
               color: #333333;
               span {
                   font-size: 16px;
                   color: #2961EF;
                   margin-left: 20px;
               }
           }
           .timebox {
               height: 35px;
               background: #f7f7f7;
               margin: 15px 0;
               width: 100%;
               span {
                   display: inline-block;
                   font-size: 14px;
                   color: #9a9999;
                   padding: 0 10px;
                   line-height: 35px;
                   &::after {
                       content: '';
                       display: inline-block;
                       width: 1px;
                       height: 11px;
                       background: #9a9999;
                       margin-left: 20px;
                   }
                   &:last-child::after {
                       content: '';
                       display: inline-block;
                       width: 0;
                   }
               }
           }
           .time {
               span {
                   font-size: 14px;
                   color: #888888;
                   padding: 0 10px;
                   display: inline-block;
                   &::after {
                       content: '';
                       display: inline-block;
                       width: 1px;
                       height: 11px;
                       background: #888888;
                       margin-left: 20px;
                   }
                   &:last-child::after {
                       content: '';
                       display: inline-block;
                       width: 0;
                   }
               }
           }
           .cont {
               font-size: 14px;
               color: #777777;
               text-indent: 2em;
               line-height: 25px;
               margin: 15px 0;
           }
           .explain {
               span {
                   display: inline-block;
                   padding: 0 20px;
                   height: 29px;
                   line-height: 29px;
                   text-align: center;
                   background: #f0f7ff;
                   border-radius: 5px 5px 5px 5px;
                   border: 1px solid #b4d4f8;
                   font-size: 14px;
                   color: #2961EF;
               }
               .span1 {
                   background: #f1faf2;
                   color: #4da52e;
                   margin: 0 12px;
                   border: 1px solid #b2e8b6;
               }
               .span2 {
                   border: 1px solid #f8d1b4;
                   background: #fff8f0;
                   color: #2961EF;
               }
           }
           .money {
               margin-top: 30px;
               display: flex;
               .span1 {
                   font-size: 25px;
                   color: #2961EF;
               }
               .must {
                   margin: 0 24px 0 33px;
                   display: flex;
                   align-items: center;
                   font-size: 16px;
                   color: #ffffff;
                   img {
                       width: 18px;
                       height: 18px;
                   }
                   height: 37px;
                   line-height: 37px;
                   background: #2961EF;
                   border-radius: 24px 24px 24px 24px;
                   padding: 0 30px;
               }
               .add {
                   width: 156px;
                   height: 36px;
                   line-height: 36px;
                   text-align: center;
                   background: #2e2e2e;
                   border-radius: 31px 31px 31px 31px;
                   font-size: 16px;
                   color: #ffffff;
               }
           }
       }
   }
   // 班级课程
   .title {
       width: 100%;
       height: 53px;
       line-height: 53px;
       background: #f7f8fa;
       border-radius: 5px 5px 5px 5px;
       font-size: 20px;
       color: #333333;
       &::before {
           content: '';
           display: inline-block;
           width: 6px;
           height: 18px;
           background: #2961EF;
           margin: 0 10px;
       }
   }
   // 推荐课程
   .courselist {
       display: flex;
       flex-wrap: wrap;
       justify-content: space-between;
       margin-top: 22px;
       .courbox {
           border-radius: 5px 5px 5px 5px;
           border: 1px solid #f1f1f1;
           padding: 10px 10px 0;
           width: 17.5%;
           margin-bottom: 18px;
           position: relative;
           .play {
               position: absolute;
               top: 15px;
               left: 15px;
               background: rgba(255, 106, 0, 0.8);
               border-radius: 5px 5px 5px 5px;
               padding: 3px 10px;
               font-size: 14px;
               color: #ffffff;
               img {
                   margin-right: 5px;
               }
           }
           .hour {
               position: absolute;
               top: 15px;
               right: 15px;
               background: rgba(255, 106, 0, 0.8);
               border-radius: 5px 5px 5px 5px;
               padding: 3px 10px;
               font-size: 14px;
               color: #ffffff;
           }
           img {
           }
           .tit {
               font-size: 14px;
               color: #383838;
               margin-bottom: 25px;
           }
           .bottom {
               height: 40px;
               border-top: 1px solid #f1f1f1;
               img {
                   vertical-align: middle;
                   width: 21px;
                   height: 21px;
                   border-radius: 50%;
               }
               .person {
                   vertical-align: middle;
                   line-height: 41px;
                   padding: 0 15px 0 10px;
                   font-size: 14px;
                   color: #888888;
                   &::after {
                       content: '';
                       border: 1px solid rgba(112, 112, 112, 0.3);
                       height: 2px;
                       margin-left: 10px;
                   }
               }
               .num {
                   vertical-align: middle;
                   line-height: 41px;
                   font-size: 14px;
                   color: #888888;
               }
               .money {
                   vertical-align: middle;
                   line-height: 41px;
                   font-size: 14px;
                   color: #2961EF;
                   float: right;
               }
           }
       }
   }
   // 分页
   .paging {
       width: 534px;
       height: 50px;
       background: rgba(112, 112, 112, 0.18);
       border-radius: 37px 37px 37px 37px;
       margin: 35px auto;
       display: flex;
       align-items: center;
       font-size: 16px;
   
       font-weight: 300;
       color: #888888;
       justify-content: space-around;
       text-align: center;
       div {
           height: 50px;
           line-height: 50px;
           border-right: 1px solid rgba(112, 112, 112, 0.2);
           width: 20%;
           &:nth-child(5) {
               border: none;
           }
       }
   }
   
</style>